export const defaultState = () => {
    return {
        start: null,
        uuid: null,
        patient_uuid: null
    }
}

const state = defaultState()
export default state
